import { Category } from './../../api';
import { isArray, isArrayOf, isNotNil, isString } from './../predicates/predicates';

/**
 * Extracts the last category element
 *
 * @param aCategory     the category
 * @param aIndex        category index
 * @param aFallback     fallback
 *
 * @return the last element
 */
export const getCategoryLeaf = (aCategory: Category, aIndex?: number, aFallback?: string): string => {
    // check
    if (isNotNil(aCategory)) {
        // the paths
        const paths = aCategory.categoryPaths;
        if (isArray(paths)) {
            // access the indexed category
            const idx = aIndex || 0;
            if (paths.length > idx) {
                // access
                const path = paths[idx];
                if (isArrayOf(path, isString) && (path.length > 0)) {
                    // return the last element
                    return path[path.length - 1] || aFallback;
                }
            }
        }
    }
    // fallback
    return aFallback;
}